import React from 'react';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
import { W9FileUploadField } from './components/W9FileUploadField';
import { W9FileNameDisplay } from './components/W9FileNameDisplay';
import { W9OnFileDisplay } from './components/W9OnFileDisplay';

export const W9Panel: React.FC = () => {
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const hasSubmittedW9 = useBrokerDetailsStore((s) => s.hasSubmittedW9);
    const w9FileName = useBrokerDetailsStore((s) => s.w9FileName);

    if (!isBroker) return null;

    return (
        <>
            {!hasSubmittedW9 && !w9FileName && <W9FileUploadField />}
            {w9FileName && <W9FileNameDisplay />}
            {hasSubmittedW9 && <W9OnFileDisplay />}
        </>
    );
};
